import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import MainLayout from '../layouts/MainLayout';
import Login from '../pages/Login';
import menuItems from '../menu-items';
import getChildRoutes, { getAllowedRoutes } from './getAllowRoutes';
export default function Router() {
  const routes = getAllowedRoutes(menuItems.items);
  const controlInOut = routes.find((route) => route.url == '/control-in-out');
  return (
    <BrowserRouter>
      <Routes>
        {/* PrivateRoute */}
        <Route path="/" element={<PrivateRoute />}>
          <Route path="/" element={<MainLayout />}>
            <Route path="/" element={<Navigate to="/summary-in-out" replace />} />
            {routes.map((route) => {
              if (route.children) {
                return getChildRoutes(route.children);
              }
              if (!route.component) return null;

              return <Route key={route.url} path={route.url} element={route.component} />;
            })}
            {controlInOut ? (
              <Route path="*" element={<Navigate to="/control-in-out" replace />} />
            ) : (
              <Route
                path="*"
                element={
                  <div style={{ padding: '2rem' }}>
                    <h1>404 Error</h1>
                    <h2>Page Not Found</h2>
                  </div>
                }
              />
            )}
          </Route>
        </Route>
        {/* PublicRoute */}
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}
